module.exports = __webpack_public_path__ + "7241e5964182151f16692b8b04063ddb.png";